import { render } from "./BlockListView.vue?vue&type=template&id=2d5ee6b6"
import script from "./BlockListView.vue?vue&type=script&lang=js"
export * from "./BlockListView.vue?vue&type=script&lang=js"

import "./BlockListView.vue?vue&type=style&index=0&id=2d5ee6b6&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__